/* eslint-disable react/jsx-handler-names */

import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedText, formatText } from 'core/i18n';
import Storage from 'utilities/storage';
import UtagHelper from 'utilities/utagHelper';
import { post } from 'utilities/APIRequestHelper';
import { getUserProfileData } from 'utilities/userProfile';
import { PROCESS_TYPE_ONBOARDING } from 'utilities/uTagConstants';
import { checkConditionAndExecuteCallback } from 'utilities/toggling';
import { RELIABLE, errorTag, PAGE_PRODUCT, recordEvent } from 'utilities/uTagging';
import HeadlineTitle from 'componentsV2/HeadlineTitle/HeadlineTitle';
import MessagesScreen from 'components/messagesScreen/messagesScreen';
import CreditCardInePDF from 'components/CreditCardComponents/CreditCardInePDF/CreditCardInePDF';
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
import CreditCardConfiguration from 'components/CreditCardComponents/CreditCardConfiguration/CreditCardConfiguration';
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
import { welcomeCard as WelcomeCard } from 'components/welcomeCard/welcomeCard';
import { PUBLICA_URL } from 'constants/index';
import { EVENT_ACEPT_MODAL, EVENT_CLOSE_MODAL } from 'constants/RAConstants';
import { ERROR_IBAN_INPUT, ERROR_IBAN_SERVICIO } from 'constants/analyticsErrors';
import { PATH_ERROR, PATH_CREDIT_CARD, CREDIT_CARD_TAG } from 'constants/uTagConstants/paths';
import { LIMIT_CREDIT, EXTERNAL_IBAN, LIMIT_CREDIT_INE } from 'constants/statusProcess';
import { WAITING_STATUS, FAILED_STATUS, SUCCESS_STATUS } from 'constants/pollingConstants';
import withPollingModalFeature from 'hocs/withPollingModalFeature';
import { resetIban } from 'actions/ibanActions';
import { recordAndSavePage } from 'actions/errorViewNavigation';
import { hidePreLoader, showPreLoader } from 'actions/preLoaderActions';
import { getCreditCardPDF, insertIbanCreditCard } from 'actions/creditCardActions';
import { startPolling, stopPolling, updatePollingStats } from 'actions/polling';
import {
    enableFinishedAndNextStep,
    changeCurrentStep,
    changeMinFinalizeStep,
    finalizeStep,
    registerCreditCard,
} from 'actions/stepsActions';
import { error } from 'ok-iban/dist/actions/OKIban';
import { actions } from 'react-redux-form';
import cryptoJS from 'crypto-js';

const { change } = actions;

class CreditCardConfigurationView extends PureComponent {
    state = {
        isClicked: true,
        creditCardContractPDF: '',
        modalContent: '',
        isValidatingOnline: false,
        ibanPollingStatus: WAITING_STATUS,
    };

    componentDidMount = async () => {
        const { userProfile, products, immStepsState, userProfileStatus: status, recordAndSavePage } = this.props;
        const JointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);
        const docNumberEncrypted = userProfile.docNumber ? cryptoJS.SHA256(userProfile.docNumber).toString() : '';
        this.checkIfIsNeededToSetCreditCardIne(status);
        !immStepsState.get('welcomeCard') &&
            recordAndSavePage(
                PATH_CREDIT_CARD,
                userProfile.recordId,
                userProfile.userId,
                `${userProfile.productType}.${userProfile.productSubtype}.${userProfile.productStandard}`,
                products.get('productsDescription'),
                userProfile.promoCode ? userProfile.promoCode : '',
                JointHolderInfo,
                RELIABLE[userProfile.identityMethod],
                '',
                userProfile.investmentType,
                {
                    tipoProceso: PROCESS_TYPE_ONBOARDING,
                    pasoProceso: CREDIT_CARD_TAG,
                    detalleProceso: '',
                    identificadorOnboarding: docNumberEncrypted,
                }
            );
    };

    checkIfIsNeededToSetCreditCardIne = status => {
        const { showPreLoader, hidePreLoader } = this.props;
        checkConditionAndExecuteCallback(status === LIMIT_CREDIT || status === LIMIT_CREDIT_INE, async () => {
            showPreLoader();
            await this.setCreditCardPdf();
            hidePreLoader();
        });
    };

    setCreditCardPdf = async () => {
        const { userProfile, getCreditCardPDF } = this.props;
        const creditCardContractPDF = await getCreditCardPDF(userProfile.accessToken);
        this.setState({ creditCardContractPDF: `data:application/pdf;base64,${creditCardContractPDF}` });
    };

    getBatchMessages = () => {
        const { hidePreLoader } = this.props;
        hidePreLoader();
        errorTag('', PATH_ERROR);

        return (
            <MessagesScreen
                iconClass="icons icons--icon-clock-type-2"
                title={formatText('messagesScreen-batchErrorTitle')}
                subtitle={formatText('messagesScreen-batchErrorSubTitle')}
                buttonText={formatText('button-understood')}
                buttonClass="form__button form__button-secondary"
                action={function () {
                    Storage.cookies.remove('accessToken');
                    Storage.cookies.remove('refreshToken');
                    window.location.href = PUBLICA_URL;
                }}
            >
                <FormattedText value="messagesScreen-batchErrorContent" />
                <FormattedText value="messagesScreen-batchErrorContent2" />
                <FormattedText value="messagesScreen-customerServiceDepartment" />
            </MessagesScreen>
        );
    };

    onHandleDisableNextButton = value => this.setState({ isClicked: value });

    onContinue = () => {
        const {
            userProfile,
            userProfile: { accessToken },
            showPreLoader,
            hidePreLoader,
            registerCreditCard,
            insertIbanCreditCard,
            immIban,
            resetIban,
            setIbanError,
        } = this.props;

        const isClicked = true;
        const iban = immIban.get('iban');

        showPreLoader();
        checkConditionAndExecuteCallback(
            userProfile.status === LIMIT_CREDIT && immIban.get('error') === '',
            async () => {
                const response = await registerCreditCard(accessToken);
                response === 'OK' ? (hidePreLoader(), this.finishSuccessCreditCardRegistered()) : hidePreLoader();
            }
        );

        checkConditionAndExecuteCallback(userProfile.status === EXTERNAL_IBAN, async () => {
            const response = await insertIbanCreditCard(accessToken, { iban });
            if (response === 'OK') this.setPollingIbanStart();
            else {
                hidePreLoader();
                resetIban();
                setTimeout(() => {
                    setIbanError('validation-preValidationIbanError');
                }, 250);
            }
        });

        checkConditionAndExecuteCallback(userProfile.status === LIMIT_CREDIT_INE, async () => {
            const response = await registerCreditCard(accessToken);
            response === 'OK' ? (hidePreLoader(), this.finishSuccessCreditCardRegistered()) : hidePreLoader();
        });

        this.setState({ isClicked });
    };

    setPollingIbanStart = async () => {
        const { hidePreLoader } = this.props;
        hidePreLoader();
        this.setState({ modalContent: this.createBodyModal(WAITING_STATUS), isValidatingOnline: true });
        setTimeout(() => {
            this.startOnlineIbanPolling();
        }, 500);
    };

    finishSuccessCreditCardRegistered = () => {
        const { enableFinishedAndNextStep, changeCurrentStep, changeMinFinalizeStep, finalizeStep, immStepsState } =
            this.props;

        setTimeout(() => {
            const currentIndex = immStepsState.get('currentStep');
            enableFinishedAndNextStep();
            changeCurrentStep({ index: currentIndex + 1 });
            changeMinFinalizeStep({ index: 4 });
            finalizeStep({ index: currentIndex, finished: true });
        }, 1000);
    };

    ibanPollValidationCallback = response => {
        const {
            ok,
            body: { status },
        } = response;

        if (ok && status !== SUCCESS_STATUS) this.setState({ modalContent: this.createBodyModal(status) });
        if (ok && status !== WAITING_STATUS) return false;

        return true;
    };

    handleFinishIbanPolling = (response, stats) => {
        const { handleModalOnPollFinished } = this.props;
        const { ok } = stats;
        const {
            body: { status },
        } = response;
        if (ok) {
            if (status !== SUCCESS_STATUS) handleModalOnPollFinished(status);
            this.onHandleIbanValidationPollinResponsesFinished(status);
        }
    };

    onHandleIbanValidationPollinResponsesFinished = status => {
        const { resetIban, change, showPreLoader, hidePreLoader, handleSetPollingModal } = this.props;

        this.recordIbanPollingStatusesValidation(status);

        if (status === WAITING_STATUS) return;
        if (status === SUCCESS_STATUS) {
            showPreLoader();
            setTimeout(() => {
                hidePreLoader();
                handleSetPollingModal(false, WAITING_STATUS);
                change('userProfile.status', LIMIT_CREDIT);
            }, 1000);

            return;
        }

        resetIban();
        this.setState(() => ({ isValidatingOnline: false, ibanPollingStatus: status }));
    };

    startOnlineIbanPolling = () => {
        const {
            startPollingWith,
            userProfile: { accessToken },
            updatePollingStats,
        } = this.props;

        const withModal = true;
        startPollingWith(
            {
                asyncFetch: requestQuery => {
                    const payload = {
                        header: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                        ...requestQuery,
                    };

                    if (requestQuery.query.isLast) updatePollingStats({ isLastRequest: true });

                    return post('creditCardIbanOnlineValidation', payload);
                },
                callback: this.ibanPollValidationCallback,
                callbackEnd: this.handleFinishIbanPolling,
                delay: 1,
                ttl: 240,
                retryOnFailure: true,
                retryAfter: 2,
                stopAfterRetries: 2,
                maxRequests: 12,
            },
            withModal
        );
    };

    onHandleClickModalCloseOrAccept = ({ eventAction }) => {
        const {
            polling: { isLastRequest },
        } = this.props;
        this.setState({ modalContent: this.createBodyModal(WAITING_STATUS), isValidatingOnline: false });
        this.recordIbanPollingStatusesEvent({
            eventTag: `modal validacion iban/${isLastRequest ? ERROR_IBAN_SERVICIO : ERROR_IBAN_INPUT}`,
            eventAction,
        });
    };

    createBodyModal = activeModal => {
        switch (activeModal) {
            case FAILED_STATUS: {
                const {
                    polling: { isLastRequest },
                } = this.props;

                return {
                    icon: <span className="icons icons--icon-warning" />,
                    body: isLastRequest
                        ? formatText('ibanOnline-timeOutModalBody')
                        : formatText('ibanOnline-errorModalBody'),
                    head: isLastRequest
                        ? formatText('ibanOnline-timeOutModalHead')
                        : formatText('ibanOnline-errorModalHead'),
                    buttonText: isLastRequest
                        ? formatText('ibanOnline-timeOutModalButtonText')
                        : formatText('ibanOnline-errorUnderstood'),
                    withButton: true,
                    onAccept: () => this.onHandleClickModalCloseOrAccept({ eventAction: EVENT_ACEPT_MODAL }),
                    onClose: () => this.onHandleClickModalCloseOrAccept({ eventAction: EVENT_CLOSE_MODAL }),
                };
            }
            case WAITING_STATUS:
                return {
                    icon: <span className="icons icons--icon-waiting-key" />,
                    body: formatText('ibanOnline-waitingModalBody'),
                    head: formatText('ibanOnline-waitingModalHead'),
                    withButton: false,
                    onClose: () =>
                        this.setState({
                            modalContent: this.createBodyModal(WAITING_STATUS),
                            isValidatingOnline: false,
                        }),
                };
        }
    };

    recordIbanPollingStatusesValidation = status => {
        switch (status) {
            case WAITING_STATUS:
                this.recordIbanPollingStatusesEvent({
                    eventTag: 'vista',
                    eventAction: 'modal validacion iban/comprobando',
                });
                break;
            case FAILED_STATUS: {
                const {
                    polling: { isLastRequest },
                } = this.props;
                this.recordIbanPollingStatusesEvent({
                    eventTag: 'vista',
                    eventAction: `modal validacion iban/${isLastRequest ? ERROR_IBAN_SERVICIO : ERROR_IBAN_INPUT}`,
                });
                break;
            }
        }
    };

    recordIbanPollingStatusesEvent = ({ eventAction, eventTag }) => {
        const { encryptedDocNumber, recordId, userId, investmentType } = getUserProfileData(this.props);
        recordEvent(
            PATH_CREDIT_CARD,
            PAGE_PRODUCT,
            eventAction,
            eventTag,
            recordId,
            userId,
            RELIABLE[this.props.userProfile.identityMethod],
            investmentType,
            encryptedDocNumber,
            { categoriaEvento: PATH_CREDIT_CARD, accionEvento: eventAction, etiquetaEvento: eventTag }
        );
    };

    renderProfile = () => {
        const { errorState, userProfile, renderPollingModal } = this.props;
        const { creditCardContractPDF, isClicked, modalContent, ibanPollingStatus } = this.state;

        if (errorState.batchError) return <div className="profesional-data-view">{this.getBatchMessages()}</div>;

        const isExternalIban = userProfile.status === EXTERNAL_IBAN;
        const isLimitCredit = userProfile.status === LIMIT_CREDIT;
        const isLimitCreditIne = userProfile.status === LIMIT_CREDIT_INE;

        return (
            <div className="profesional-data-view">
                <div className="prospects-step-content basic-layering">
                    <HeadlineTitle />
                    <section className={'openCredit-container'}>
                        <ConditionalToggling condition={isExternalIban}>
                            <CreditCardConfiguration
                                setCreditCardPdf={() => this.checkIfIsNeededToSetCreditCardIne(userProfile.status)}
                                ibanPollingStatus={ibanPollingStatus}
                                handleDisableNextButton={this.onHandleDisableNextButton}
                            />
                        </ConditionalToggling>

                        <ConditionalToggling condition={isLimitCredit}>
                            <CreditCardInePDF
                                handleDisableNextButton={this.onHandleDisableNextButton}
                                pdfFile={creditCardContractPDF}
                                togglingCondition={true}
                            />
                        </ConditionalToggling>

                        <ConditionalToggling condition={isLimitCreditIne}>
                            <CreditCardConfiguration
                                setCreditCardPdf={() => this.checkIfIsNeededToSetCreditCardIne(userProfile.status)}
                                ibanPollingStatus={ibanPollingStatus}
                                handleDisableNextButton={this.onHandleDisableNextButton}
                            />
                            <CreditCardInePDF
                                handleDisableNextButton={this.onHandleDisableNextButton}
                                pdfFile={creditCardContractPDF}
                                togglingCondition={true}
                            />
                        </ConditionalToggling>
                    </section>
                    <div className="row form__footer">
                        <div className="col-lg-12">
                            <RoadmapNavigation
                                buttonPrevSpecialHidden={true}
                                buttonPrevHidden={true}
                                buttonContinueAction={this.onContinue}
                                buttonContinueDisabled={isClicked}
                            />
                        </div>
                    </div>
                </div>
                {renderPollingModal(userProfile, modalContent)}
                <WelcomeCard />
            </div>
        );
    };

    render = () => {
        return <div className="basic-layering">{this.renderProfile()}</div>;
    };
}

module.exports.constructor = CreditCardConfigurationView;
module.exports.CreditCardConfigurationView = connect(
    state => ({
        errorState: state.error,
        userProfile: state.userProfile,
        immStepsState: state.steps,
        products: state.products,
        polling: state.polling,
        immIban: state.iban,
        userProfileStatus: state.userProfile.status,
    }),
    dispatch => ({
        change,
        resetIban,
        enableFinishedAndNextStep,
        changeCurrentStep,
        changeMinFinalizeStep,
        finalizeStep,
        getCreditCardPDF,
        hidePreLoader,
        showPreLoader,
        registerCreditCard,
        startPolling,
        stopPolling,
        updatePollingStats,
        insertIbanCreditCard,
        setIbanError: error,
        recordAndSavePage: bindActionCreators(recordAndSavePage, dispatch),
    })
)(withPollingModalFeature(CreditCardConfigurationView));
